import React from 'react';

const ReassignOverlay = ({ overlayClass }) => {
    return (
        <div className={overlayClass}>
            <div className="form-action-overlay__content">
                <svg className="icon icon-logo">
                    <use xlinkHref="#icon-logo" />
                </svg>

                <div className="form-action-overlay__text">Reassigning</div>

                <svg
                    className="loading__spinner"
                    width="60"
                    height="20"
                    viewBox="0 0 60 20"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <circle cx="7" cy="15" r="4" />
                    <circle cx="30" cy="15" r="4" />
                    <circle cx="53" cy="15" r="4" />
                </svg>
            </div>
        </div>
    );
};
export default ReassignOverlay;



// WEBPACK FOOTER //
// ./src/components/admin/overlay.js